import React, { useState, useRef, useEffect } from 'react';
import { filtrarFincas } from '../utils/buscar';

// Escoger una finca cuando hay muchas.
//
// El desplegable de siempre obliga a bajar por una lista de cincuenta nombres
// en orden alfabético, en un teléfono, parado en una finca a las cinco de la
// mañana. Con la caja se escriben tres letras y ya.
//
// ── Por qué no es un `select` con buscador ──
//
// Un `select` no deja escribir: el navegador solo salta a la primera letra, y
// dos fincas que empiecen igual obligan a teclear rápido y adivinar. Esto es
// una caja de texto de verdad, y busca también por DUEÑO y por CÉDULA —que es
// como se acuerda uno de la gente— no solo por el nombre de la finca.
//
// ── Lo que se mantiene del original ──
//
// Sigue siendo obligatorio elegir una. Al elegir se avisa al de afuera, que es
// quien pone el precio pactado: esta pantalla escoge, no sabe de plata.

// Cuántas se muestran mientras se busca. Más no caben en un teléfono sin
// tapar el resto del formulario, y quien ve veinte resultados no ha buscado:
// sigue mirando una lista.
const CUANTAS = 8;

function ElegirFinca({ fincas, valor, alElegir, autoFoco = false }) {
  const [busca, setBusca] = useState('');
  const [abierto, setAbierto] = useState(false);
  const caja = useRef(null);

  const elegida = (fincas || []).find(f => String(f.id) === String(valor));

  useEffect(() => {
    if (autoFoco && !elegida && caja.current) caja.current.focus();
  }, [autoFoco, elegida]);

  // Ya hay una escogida: se enseña cuál y se ofrece cambiarla. Dejar la caja
  // de búsqueda con el nombre adentro invita a borrarlo sin querer y quedarse
  // sin finca a medio formulario.
  if (elegida && !abierto) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', gap: 10,
        border: '1px solid var(--linea)', borderRadius: 8, padding: '9px 12px',
        background: 'var(--hondo)',
      }}>
        <div style={{ minWidth: 0, flex: 1 }}>
          <div className="recio">{elegida.nombre}</div>
          {(elegida.propietario || elegida.documento) && (
            <div style={{ fontSize: 12, color: 'var(--tinta-tenue)' }}>
              {[elegida.propietario, elegida.documento].filter(Boolean).join(' · ')}
            </div>
          )}
        </div>
        <button type="button" className="boton chico suave"
                onClick={() => { setBusca(''); setAbierto(true); }}>
          Cambiar
        </button>
      </div>
    );
  }

  const halladas = filtrarFincas(fincas, busca);
  const escoger = (f) => { alElegir(String(f.id)); setBusca(''); setAbierto(false); };

  return (
    <div>
      <input
        ref={caja}
        value={busca}
        onChange={e => setBusca(e.target.value)}
        placeholder="Escriba la finca, el dueño o la cédula"
        // Enter escoge la primera, que con tres letras escritas suele ser la
        // que se busca. Y evita que el formulario se envíe a medio llenar.
        onKeyDown={e => {
          if (e.key !== 'Enter') return;
          e.preventDefault();
          if (halladas.length > 0) escoger(halladas[0]);
        }}
        style={{ width: '100%', boxSizing: 'border-box', padding: '11px 14px',
                 fontSize: 16, borderRadius: 8, border: '1px solid var(--linea)' }} />

      <div style={{ marginTop: 6, border: '1px solid var(--linea)',
                    borderRadius: 8, overflow: 'hidden' }}>
        {halladas.length === 0 ? (
          <div style={{ padding: '12px 14px', fontSize: 14, color: 'var(--tinta-tenue)' }}>
            Ninguna finca con «{busca}». Pruebe con parte del nombre, del dueño
            o de la cédula.
          </div>
        ) : (
          <>
            {halladas.slice(0, CUANTAS).map(f => (
              <button key={f.id} type="button" onClick={() => escoger(f)}
                      style={{
                        display: 'block', width: '100%', textAlign: 'left',
                        padding: '10px 14px', border: 'none', cursor: 'pointer',
                        background: 'var(--tarjeta)',
                        borderBottom: '1px solid var(--raya-suave)', font: 'inherit',
                      }}>
                <div className="recio">{f.nombre}</div>
                {(f.propietario || f.documento) && (
                  <div style={{ fontSize: 12, color: 'var(--tinta-tenue)' }}>
                    {[f.propietario, f.documento].filter(Boolean).join(' · ')}
                  </div>
                )}
              </button>
            ))}
            {/* Cuántas quedaron fuera. Sin decirlo, quien no ve la suya entre
                las ocho cree que no está en el programa. */}
            {halladas.length > CUANTAS && (
              <div style={{ padding: '9px 14px', fontSize: 12,
                            color: 'var(--tinta-tenue)', background: 'var(--hondo)' }}>
                y {halladas.length - CUANTAS} más — escriba un poco más para
                acortar la lista
              </div>
            )}
          </>
        )}
      </div>

      {elegida && (
        <button type="button" className="boton chico suave"
                style={{ marginTop: 6 }}
                onClick={() => setAbierto(false)}>
          Cancelar y dejar {elegida.nombre}
        </button>
      )}
    </div>
  );
}

export default ElegirFinca;
